import React, { useState } from "react"
import { Row, Col, Card, Form, CardBody, Container } from "reactstrap"
import Dropzone from "react-dropzone"

import { Link } from "react-router-dom"

const UploadForm = props => {
  const { uploadData } = props

  //meta title
  document.title =
    "Form File Upload | TenderSoftware - Flexi TracBoard"

  const [selectedFiles, setselectedFiles] = useState([])

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles(files)
  }
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  return (
    <React.Fragment>
      <div>
        <Container fluid={true}>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Form>
                    <Dropzone
                      onDrop={acceptedFiles => {
                        handleAcceptedFiles(acceptedFiles)
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div
                            className="dz-message needsclick mt-2"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} multiple={false} />
                            <div className="mb-3">
                              <i className="display-4 text-muted bx bxs-cloud-upload" />
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="dropzone-previews mt-3" id="file-previews">
                      {selectedFiles.map((f, i) => {
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col>
                                  <Link
                                    to="#"
                                    className="text-muted font-weight-bold"
                                  >
                                    {f.name}
                                  </Link>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        )
                      })}
                    </div>
                  </Form>
                  <div className="text-end mt-4">
                    <button
                      type="button"
                      className="btn btn-primary me-2 "
                      onClick={() => {
                        uploadData(selectedFiles)
                      }}
                    >
                      Upload
                    </button>
                    {/* <button
                      type="button"
                      className="btn btn-primary "
                      onClick={() => {
                        window.location.href =
                          "https://file-examples.com/wp-content/storage/2017/02/file_example_XLS_10.xls"
                      }}
                    >
                      Download
                    </button> */}
                    <a
                      target="_blank"
                      className="btn btn-primary "
                      rel="noreferrer"
                      href="https://file-examples.com/wp-content/storage/2017/02/file_example_XLS_10.xls"
                    >
                      Download
                    </a>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UploadForm
